module.exports = __webpack_public_path__ + "img/olympus.1787cb91.jpeg";